import React from "react";
import { Block, Editor } from "slate";
import { Option, SelectItem } from "../../selectItem";
import { BLOCKS } from "../html";

import "./stylePicker.scss";

interface Props {
  editorRef: Editor;
}

const getCurrentBlockType = (block: Block) => {
  switch (block ? block.type : "") {
    case BLOCKS.HEADING1.type:
    case BLOCKS.HEADING2.type:
    case BLOCKS.HEADING3.type:
      return block.type;
    default:
      return BLOCKS.PARAGRAPH.type;
  }
}

export const StylePicker = ({ editorRef }: Props) => {
  const onSelect = (value: string) => {
    editorRef.command(`toggle_${value}`);
    editorRef.focus();
  };

  return (
    <SelectItem
      className="slate-toolbar__style-picker"
      dropdownClassName="slate-toolbar__style-picker-dropdown"
      value={getCurrentBlockType(editorRef.value.focusBlock)}
      onSelect={onSelect}
    >
      <Option value={BLOCKS.PARAGRAPH.type}>
        <p>Normal</p>
      </Option>
      <Option value={BLOCKS.HEADING1.type}>
        <h1>Heading 1</h1>
      </Option>
      <Option value={BLOCKS.HEADING2.type}>
        <h2>Heading 2</h2>
      </Option>
      <Option value={BLOCKS.HEADING3.type}>
        <h3>Heading 3</h3>
      </Option>
    </SelectItem>
  );
}